import { Component, TemplateFunction } from '@ribajs/core'
import { ShopifyProductRecommendationsService } from '../services'
import { TwSlideshowComponent } from '../modules/tailwind/components'

import type { ShopifyProduct, ShopifyCartLineItem } from '../types'
import type { JsxSbCartRecommendationsProps } from '../types/jsx'
import type { SlideshowSlide } from '../modules/tailwind/types'

interface Scope {
  items: ShopifyCartLineItem[]
  recommendations: ShopifyProduct[]
  slides: SlideshowSlide<ShopifyProduct>[]
}

/**
 * A component to get the product recommendations for each line item in the cart
 */
export class SbCardRecommendationsComponent extends Component {
  public static tagName = 'sb-cart-recommendations'

  public slideshow?: TwSlideshowComponent

  static get observedAttributes(): (keyof JsxSbCartRecommendationsProps)[] {
    return ['items']
  }

  protected requiredAttributes(): string[] {
    return ['items']
  }

  public scope: Scope = {
    items: new Array<ShopifyCartLineItem>(),
    recommendations: new Array<ShopifyProduct>(),
    slides: new Array<SlideshowSlide<ShopifyProduct>>(),
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbCardRecommendationsComponent.observedAttributes)
  }

  protected async afterBind() {
    await super.afterBind()
    this.slideshow =
      this.querySelector(TwSlideshowComponent.tagName) || undefined
    this.classList.add(`${SbCardRecommendationsComponent.tagName}-ready`)
  }

  protected updateSlides() {
    const slides = new Array<SlideshowSlide<ShopifyProduct>>()
    for (let i = 0; i < this.scope.recommendations.length; i++) {
      const recommendation = this.scope.recommendations[i]
      slides.push({
        active: false,
        index: i,
        data: recommendation,
      })
    }
    this.scope.slides = slides
    this.slideshow?.updateItems()
  }

  protected async getRecommendations() {
    if (this.scope.items?.length) {
      const productIds = this.scope.items.map(item => item.product_id) || []
      this.scope.recommendations =
        await ShopifyProductRecommendationsService.get(productIds, 8)
    } else {
      this.scope.recommendations = []
    }

    this.updateSlides()
  }

  protected parsedAttributeChangedCallback(
    attributeName: string,
    oldValue: any,
    newValue: any,
    namespace: string | null,
  ) {
    super.parsedAttributeChangedCallback(
      attributeName,
      oldValue,
      newValue,
      namespace,
    )
    switch (attributeName) {
      case 'items':
        this.getRecommendations()
        break
    }
  }

  protected template(): ReturnType<TemplateFunction> {
    return null
  }
}
